function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M40 20C40 31.046 31.046 40 20 40C8.954 40 0 31.046 0 20C0 8.954 8.954 0 20 0C31.046 0 40 8.954 40 20ZM13.94 13.94C14.2213 13.6591 14.6025 13.5013 15 13.5013C15.3975 13.5013 15.7787 13.6591 16.06 13.94L20 17.88L23.94 13.94C24.2243 13.675 24.6004 13.5308 24.989 13.5376C25.3776 13.5445 25.7484 13.7019 26.0232 13.9768C26.2981 14.2516 26.4555 14.6224 26.4624 15.011C26.4692 15.3996 26.325 15.7757 26.06 16.06L22.12 20L26.06 23.94C26.325 24.2243 26.4692 24.6004 26.4624 24.989C26.4555 25.3776 26.2981 25.7484 26.0232 26.0232C25.7484 26.2981 25.3776 26.4555 24.989 26.4624C24.6004 26.4692 24.2243 26.325 23.94 26.06L20 22.12L16.06 26.06C15.7757 26.325 15.3996 26.4692 15.011 26.4624C14.6224 26.4555 14.2516 26.2981 13.9768 26.0232C13.7019 25.7484 13.5445 25.3776 13.5376 24.989C13.5308 24.6004 13.675 24.2243 13.94 23.94L17.88 20L13.94 16.06C13.6591 15.7787 13.5013 15.3975 13.5013 15C13.5013 14.6025 13.6591 14.2213 13.94 13.94Z",
  fill: "#3D008C"
});

function SvgCorss(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorss);
export default __webpack_public_path__ + "static/media/Corss.961d2a9f.svg";
export { ForwardRef as ReactComponent };